import axios from 'axios'
import {
  config,
  findCurrentlyActiveChallenge,
  options,
  unknownError,
} from '../../common/utility'
import {
  GET_CHALLENGE_DETAILS,
  UPDATE_CHALLENGE_PROGRESS,
  UPDATE_CHALLENGE_PROGRESS_ERROR,
} from '../types'

const authenticatedUserRole = 'CAMPER'

export const getChallengesProgress = () => async (dispatch, getState) => {
  try {
    const { user, auth } = getState().authReducer
    const res = await axios({
      method: 'post',
      url: `${config.REACT_APP_GATEWAY_API_ENDPOINT}engagement/v1/challenges/progress`,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${auth?.token}`,
      },
      data: { userIds: [user?.id] },
    })
    const userRegisteredChallenges =
      res?.data[0].challengeSummaryProgressDtos ?? []
    const activeChallenge =
      findCurrentlyActiveChallenge(userRegisteredChallenges) ?? null
    const hasPreviousChallenges = !!userRegisteredChallenges?.length
    dispatch({
      type: GET_CHALLENGE_DETAILS,
      payload: {
        isRegisteredForActiveFit: !!activeChallenge,
        challenges: userRegisteredChallenges,
        activeChallenge,
        hasPreviousChallenges,
      },
    })
    return Promise.resolve(res?.data)
  } catch (err) {
    const errorMessage = err?.message ?? unknownError
    dispatch({
      type: GET_CHALLENGE_DETAILS,
    })
    return Promise.reject(errorMessage)
  }
}

export const updateChallengeStats =
  (userSubmittedStats) => async (dispatch, getState) => {
    try {
      const { user, auth } = getState().authReducer
      const { activeChallenge } = getState().challengeReducer
      const userId = user?.id
      const res = await axios({
        method: 'post',
        url: `${config.REACT_APP_GATEWAY_API_ENDPOINT}engagement/v1/cgfits`,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${auth?.token}`,
          authenticatedUserId: userId,
          authenticatedUserRole,
        },
        data: JSON.stringify({
          userId,
          challengeId: activeChallenge?.challengeId,
          date: new Date().toISOString(),
          userSubmittedStats,
        }),
      })
      dispatch({
        type: UPDATE_CHALLENGE_PROGRESS,
        payload: res?.data,
      })
      return Promise.resolve(res?.data)
    } catch (err) {
      const errorMessage = err?.message ?? unknownError
      dispatch({
        type: UPDATE_CHALLENGE_PROGRESS_ERROR,
        payload: errorMessage,
      })
      return Promise.reject(errorMessage)
    }
  }
